<template>
  <div class="container">
    <typeList />
    <div v-loading="isLoading" class="my-table">
      <div
        class="table-item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div class="table-item-top">
          <div class="img">
            <img :src="item.Avatar" alt="" @error="imgError" />
          </div>
        </div>

        <div class="table-item-bottom">
          <p class="TeacherName">{{ item.TeacherName }}</p>
          <p class="PropValue">{{ showProp(item)}}</p>
        </div>
      </div>
    </div>
    <el-empty
      description="暂无内容"
      :image="empty1"
      v-if="list.length == 0 && !isLoading"
    />
    <el-pagination
      class="center my-pagination mt30 mb70"
      @current-change="(page) => getList(page)"
      background
      hide-on-single-page
      :page-size="15"
      layout="prev, pager, next"
      :total="count"
    >
    </el-pagination>
  </div>
</template>

<script>
import { Teacher_GetList } from "@/api/teacher";
import typeList from "./child/typeList.vue";
export default {
  name: "teacher",
  components: {
    typeList,
  },
  data() {
    return {
      isLoading: false,
      title: "",
      PageIndex: 1,
      list: [],
      count: 0,
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(v) {
        this.getList();
      },
    },
  },

  created() {
    this.getList();
  },
  methods: {
    showProp(item) {
      let showItem = item.Props.filter((item)=>item.IsShow) 
      if (showItem[0]) {
        return showItem[0].PropValue;
      } else {
        return item.PropValue
      }
    },
    toDetail(item) {
      this.$router.push({
        path: "/teacherDetail",
        query: { TeacherID: item.TeacherID },
      });
    },
    async getList(page = 1) {
      if (this.isLoading) {
        return;
      }
      this.PageIndex = page;
      this.isLoading = true;
      this.list = [];
      await Teacher_GetList({
        PageIndex: this.PageIndex,
        PageSize: 15,
        ...this.$route.query,
      })
        .then((res) => {
          this.list = res.data;
          this.count = res.count;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-table {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  .table-item {
    cursor: pointer;
    width: 340px;
    height: 480px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;
    &:hover {
      transform: scale(1.01);
    }
    .table-item-top {
      .img {
        width: 308px;
        height: 379px;
        border-radius: 6px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }
      }
    }
    .table-item-bottom {
      text-align: center;
      .TeacherName {
        font-weight: 400;
        font-size: 20PX;
        color: #333333;
        margin-top: 10px;
      }
      .PropValue {
        margin-top: 5px;
        font-weight: 400;
        font-size: 16PX;
        color: #999999;
      }
    }
  }
}
</style>
